import React, { useState, useEffect } from "react";
import Fetch from "./Fetch";
import { URL, TYPE, ACTION } from "./URL";
import { get_offline_item_ids, clear_offline_item_ids } from "./AuthProvider";
import { _d } from "./util";
import Table from 'react-bootstrap/Table';

export default function FetchOffout() {
    const post_data = {
      item_ids:   get_offline_item_ids(),
    };
    _d(post_data, "post_data: ");
    return (
        <Fetch
            url={new URL(ACTION.OFFOUT, null, 0, null, post_data)}
            renderSuccess={(data) => <RenderSuccess data={data.data} />}
        />
    );
}

export function RenderSuccess({data}) {
    _d(data, "RenderSuccess data: ");
    clear_offline_item_ids();
    function makeResultRow(result, index) {
        if (result.status === "OK") {
            return (
                <tr key={index}>
                    <td>出庫成功</td>
                    <td>{result.item}, {result.storage}</td>
                </tr>
            );
        } else {
            return (
                <tr key={index}>
                    <td>出庫失敗</td>
                    <td>{result.message}</td>
                </tr>
            );
        }
    }

    const count_ok = data.results.filter(result => result.status === "OK").length;
    const count_ng = data.results.length - count_ok;
    return (
        <div>
            <Table striped bordered size="sm">
                <thead>
                    <tr>
                        <th>ステータス</th>
                        <th>メッセージ</th>
                    </tr>
                </thead>
                <tbody>
                    {data.results.map((result, index) => (
                        makeResultRow(result, index)
                    ))}
                </tbody>
            </Table>
            <div>
                <br />
                {count_ok} 件の出庫が成功しました。
                <br />
                {count_ng} 件の出庫が失敗しました。
                <br />
            </div>
        </div>
    );
}
